import { LocationPlaceValue } from './company-location-search.tsx'

export const mapCompanyLocationToPlaceValue = (location: {
  address?: null | {
    address?: null | string
    address_second_line?: null | string
    city?: null | string
    country?: null | string
    country_code?: null | string
    id?: number
    lat?: null | number | string
    lng?: null | number | string
    place_id?: null | string
    place_name?: null | string
    postcode?: null | string
    uk_region?: null | string
  }
  id: number
  name: string
  provider_place_id?: null | string
}): LocationPlaceValue => ({
  address: location.address?.address ?? null,
  address_id: location.address?.id ?? null,
  address_second_line: location.address?.address_second_line ?? null,
  city: location.address?.city ?? '',
  country: location.address?.country ?? '',
  country_code: location.address?.country_code ?? '',
  lat: location.address?.lat == null ? null : String(location.address.lat),
  lng: location.address?.lng == null ? null : String(location.address.lng),
  location_id: location.id,
  name: location.name,
  place_id: location.address?.place_id ?? location.provider_place_id ?? null,
  place_name: location.address?.place_name ?? location.name,
  postcode: location.address?.postcode ?? '',
  uk_region: location.address?.uk_region ?? null,
})
